import { render } from "./TemplatesTable.vue?vue&type=template&id=7ca49c1a"
import script from "./TemplatesTable.vue?vue&type=script&lang=js"
export * from "./TemplatesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__